"use strict";

var _classCallCheck = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var convCoord = _interopRequireWildcard(require("./dot/conv-coord"));

var _matchInputs = require("./match-inputs");

var _layoutWorker = _interopRequireDefault(require("./layout.worker.bundled"));

var _types = require("./types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function cleanInput(srcEdges, srcVertices) {
  var edges = srcEdges.map(function (_ref) {
    var from = _ref.from,
        to = _ref.to,
        isBidirectional = _ref.isBidirectional;
    return {
      from: from,
      to: to,
      isBidirectional: isBidirectional
    };
  });
  var vertices = srcVertices.map(function (_ref2) {
    var key = _ref2.vertex.key,
        rest = _objectWithoutProperties(_ref2, ["vertex"]);

    return _objectSpread({
      vertex: {
        key: key
      }
    }, rest);
  });
  return {
    edges: edges,
    vertices: vertices
  };
}

function killWorker(worker) {
  var w = worker; // to make flow happy

  var noop = function noop() {};

  w.onmessage = noop; // $FlowIgnore - https://github.com/facebook/flow/issues/6191

  w.onmessageerror = noop;
  w.onerror = noop;
  w.terminate();
}

function findAndRemoveWorker(lists, worker) {
  for (var i = 0; i < lists.length; i++) {
    var list = lists[i];
    var wi = list.indexOf(worker);

    if (wi >= 0) {
      list.splice(wi, 1);
      return {
        ok: true,
        list: list
      };
    }
  }

  return {
    ok: false
  };
}

var Coordinator =
/*#__PURE__*/
function () {
  function Coordinator(callback) {
    var _this = this;

    _classCallCheck(this, Coordinator);

    this.currentLayout = void 0;
    this.nextWorkerId = void 0;
    this.idleWorkers = void 0;
    this.busyWorkers = void 0;
    this.callback = void 0;

    this._handleVizWorkerError = function (event) {
      var worker = event.target;

      var _findAndRemoveWorker = findAndRemoveWorker([_this.busyWorkers, _this.idleWorkers], worker),
          ok = _findAndRemoveWorker.ok;

      if (ok) {
        console.error('Viz worker onerror');
        console.error(event);
        killWorker(worker);
      } else {
        console.error('Viz worker onerror from unknown viz worker');
        console.error(event);
      }
    };

    this._handleVizWorkerMessageError = function (event) {
      // TODO(joe): something more useful
      var msg = {
        event: event,
        currentLayout: _this.currentLayout,
        errorType: '_handleVizWorkerMessageError'
      };
      console.error(msg);
    };

    this._handleVizWorkerMessage = function (event) {
      var worker = event.target;
      var workerMessage = event.data;
      var type = workerMessage.type;

      _this._makeWorkerIdle(worker);

      var isStale = !_this.currentLayout || Boolean(workerMessage.meta && workerMessage.meta.layoutId !== _this.currentLayout.id);

      if (type === _types.EWorkerErrorType.Error) {
        console.error("".concat(isStale ? '(stale) ' : '', "Error from viz.worker"), event);
        return;
      }

      if (isStale) {
        return;
      }

      if (type === _types.EWorkerErrorType.LayoutError) {
        // TODO(joe): implement retries with more spacing
        console.error('layout-error', event);
        return;
      }

      if (workerMessage.type === _types.EWorkerPhase.Positions || workerMessage.type === _types.EWorkerPhase.Edges || workerMessage.type === _types.EWorkerPhase.DotOnly) {
        _this._processResult(type, workerMessage);

        return;
      }

      console.error("Unknown worker message type: ".concat(type), event);
    };

    this.callback = callback;
    this.currentLayout = null;
    this.nextWorkerId = 0;
    this.idleWorkers = [];
    this.busyWorkers = [];
  }

  _createClass(Coordinator, [{
    key: "getLayout",
    value: function getLayout(id, inEdges, inVertices, options) {
      this.busyWorkers.forEach(killWorker);
      this.busyWorkers.length = 0;

      var _cleanInput = cleanInput(inEdges, inVertices),
          edges = _cleanInput.edges,
          _vertices = _cleanInput.vertices;

      var vertices = _vertices.map(convCoord.vertexToDot);

      this.currentLayout = {
        id: id,
        cleaned: {
          edges: edges,
          vertices: vertices
        },
        options: options || null,
        input: {
          edges: inEdges,
          vertices: inVertices
        },
        status: {
          phase: _types.ECoordinatorPhase.NotStarted
        }
      };
      var isDotOnly = Boolean(options && options.useDotEdges);
      var phase = isDotOnly ? _types.EWorkerPhase.DotOnly : _types.EWorkerPhase.Positions;

      this._postWork(phase, edges, vertices);
    }
  }, {
    key: "stopAndRelease",
    value: function stopAndRelease() {
      this.idleWorkers.forEach(killWorker);
      this.idleWorkers.length = 0;
      this.busyWorkers.forEach(killWorker);
      this.busyWorkers.length = 0;
      this.currentLayout = null;
    }
  }, {
    key: "_initWorker",
    value: function _initWorker() {
      var worker = new _layoutWorker.default();
      worker.id = this.nextWorkerId;
      this.nextWorkerId++;
      worker.onerror = this._handleVizWorkerError;
      worker.onmessageerror = this._handleVizWorkerMessageError;
      worker.onmessage = this._handleVizWorkerMessage;
      return worker;
    }
  }, {
    key: "_makeWorkerIdle",
    value: function _makeWorkerIdle(worker) {
      var _findAndRemoveWorker2 = findAndRemoveWorker([this.busyWorkers, this.idleWorkers], worker),
          ok = _findAndRemoveWorker2.ok;

      if (ok) {
        this.idleWorkers.push(worker);
      } else {
        killWorker(worker);
      }
    }
  }, {
    key: "_postWork",
    value: function _postWork(phase, edges, vertices) {
      if (!this.currentLayout) {
        throw new Error('_startWork called without a current layout');
      }

      var _this$currentLayout = this.currentLayout,
          id = _this$currentLayout.id,
          options = _this$currentLayout.options,
          status = _this$currentLayout.status;

      var worker = this.idleWorkers.pop() || this._initWorker();

      this.busyWorkers.push(worker);
      status.phase = phase;
      status.workerId = worker.id;
      var message = {
        options: options,
        edges: edges,
        vertices: vertices,
        meta: {
          phase: phase,
          layoutId: id,
          workerId: worker.id
        }
      };
      worker.postMessage(message);
    }
  }, {
    key: "_processResult",
    value: function _processResult(phase, workerMessage) {
      var layout = this.currentLayout;

      if (!layout) {
        // make flow happy - this is already checked and should not happen
        return;
      }

      var edges = workerMessage.edges,
          graph = workerMessage.graph,
          meta = workerMessage.meta,
          vertices = workerMessage.vertices;
      var workerId = meta.workerId;
      var cleaned = layout.cleaned,
          input = layout.input,
          status = layout.status;
      var stPhase = status.phase,
          stWorkerId = status.workerId;

      if (phase !== stPhase || workerId !== stWorkerId) {
        console.error("Have work results, but in an invalid state");
        return;
      }

      if (!vertices || !graph || phase !== _types.EWorkerPhase.Positions && !edges) {
        console.error('Have work results, but recieved invalid result data');
        return;
      }

      var adjVertexCoords = convCoord.vertexToPixels.bind(null, graph);
      var adjCleanVertices = vertices.map(adjVertexCoords);
      var adjVertices = (0, _matchInputs.matchVertices)(input.vertices, adjCleanVertices);
      var adjGraph = convCoord.graphToPixels(graph);

      if (phase === _types.EWorkerPhase.Positions || phase === _types.EWorkerPhase.DotOnly) {
        this.callback({
          type: _types.ECoordinatorPhase.Positions,
          layoutId: layout.id,
          graph: adjGraph,
          vertices: adjVertices
        });
      } // phase is either edges or dot-only


      if (edges) {
        var adjEdgeCoords = convCoord.edgeToPixels.bind(null, graph);
        var adjEdges = edges.map(adjEdgeCoords);
        adjEdges = (0, _matchInputs.matchEdges)(input.edges, adjEdges);
        this.callback({
          type: _types.ECoordinatorPhase.Done,
          layoutId: layout.id,
          graph: adjGraph,
          edges: adjEdges,
          vertices: adjVertices
        });
      }

      if (phase === _types.EWorkerPhase.Positions) {
        this._postWork(_types.EWorkerPhase.Edges, cleaned.edges, vertices);
      }
    }
  }]);

  return Coordinator;
}();

exports.default = Coordinator;